import { render, staticRenderFns } from "./ClientAutocomplete.vue?vue&type=template&id=4ef77458&scoped=true"
import script from "./ClientAutocomplete.vue?vue&type=script&lang=js"
export * from "./ClientAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./ClientAutocomplete.vue?vue&type=style&index=0&id=4ef77458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef77458",
  null
  
)

export default component.exports